import { render } from "./Kontakte.vue?vue&type=template&id=f72d7f54&scoped=true"
import script from "./Kontakte.vue?vue&type=script&lang=js"
export * from "./Kontakte.vue?vue&type=script&lang=js"

import "./Kontakte.vue?vue&type=style&index=0&id=f72d7f54&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f72d7f54"

export default script